const O = {
  CANCELLED: ["ORDER_CANCELLED"],
  COMPLETED: [],
  ALLOCATED: ["ORDER_PLACED"],
  PREPARE_ORDER: ["ORDER_PREPARING"],
  ORDER_DELIVERED: ["ORDER_DELIVERED"],
  ORDER_COLLECTED_KERRY_711: ["ORDER_COLLECTED_KERRY_711"]
}, T = {
  COMPLETED: "ORDER_COMPLETED",
  CANCELLED: "ORDER_CANCELLED"
};
var R = /* @__PURE__ */ ((E) => (E.SUCCESS = "SUCCESS", E.ORDER_DELIVERED = "ORDER_DELIVERED", E.RETURN = "RETURN", E.NOT_DELIVERED = "NOT_DELIVERED", E))(R || {});
const A = [
  "TH_OTHER",
  "CO_OTHERS",
  "TH_OTHERS",
  "CO_OTHER",
  "LATAM_OTHERS",
  "LATAM_OTHER",
  "LATAM_OTHERS_CO"
];
var _ = /* @__PURE__ */ ((E) => (E.VIEW_DETAILS = "VIEW_DETAILS", E.BUY_AGAIN = "BUY_AGAIN", E.VIEW_SOP = "VIEW_SOP", E.RETRY_PAYMENT = "RETRY_PAYMENT", E.PAY_NOW = "PAY_NOW", E.REQUEST_RETURN = "REQUEST_RETURN", E.CANCEL_ORDER = "CANCEL_ORDER", E))(_ || {}), D = /* @__PURE__ */ ((E) => (E.HYBRIS = "HYBRIS", E.NEXTGEN = "NEXTGEN", E))(D || {});
const L = [
  {
    sourceOms: "HYBRIS",
    OrderHistoryCTAs: [
      "VIEW_DETAILS",
      "BUY_AGAIN"
      /* BUY_AGAIN */
    ],
    OrderDetailsCTAs: [
      "VIEW_SOP",
      "BUY_AGAIN",
      "REQUEST_RETURN"
      /* REQUEST_RETURN */
    ]
  }
], C = {
  FREE: "FREE",
  NumberRegex: /\d/
};
export {
  A,
  O as C,
  _ as D,
  L as I,
  D as L,
  C as T,
  R as _,
  T as r
};
//# sourceMappingURL=postpurchaseEnums-19d3e31f.mjs.map
